import { Injectable } from '@angular/core';
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { catchError, concatMap, mapTo, tap } from "rxjs/operators";
import { ResponseWSWidget } from '../model/widget.model';
@Injectable({
  providedIn: 'root'
})
export class WidgetService {
  constructor(private httpClient: HttpClient) { }
  baseUrl = environment.baseUrl;

  public getAddress(lat: number | string, lng: number | string): any {
    const base_url = this.baseUrl;
    const base_route = "tool/geocode?";
    const latlng_route = 'latitude=' + lat.toString() + '&longitude=' + lng.toString();
    return this.httpClient.get<any>(
      `${base_url}${base_route}${latlng_route} `

    );
  }

  public postUploadEndpoint(header: {
    content_type: string;
  }, file: File): Observable<any> {
    const base_url = this.baseUrl;
    const base_route = "file/upload";
    const response_widget = new ResponseWSWidget();
    return this.httpClient
      .post<any>(`${base_url}${base_route}`, file).pipe(
        tap(
          (_response: any) => {
            response_widget.success = _response.success;
            response_widget.data = _response.data;
          }
        ),
        mapTo(response_widget),
        catchError(error => {
          return of(response_widget);
        }));

  }
} 